import React, { useEffect, useState } from "react";
import { Pencil, Check, X, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

let optsCache = null;
const loadOpts = () => {
  if (!optsCache) {
    optsCache = api.get("/tasks/meta/form-options").then((r) => r.data).catch(() => { optsCache = null; return {}; });
  }
  return optsCache;
};

export function useFormOptions(key, enabled) {
  const [list, setList] = useState([]);
  useEffect(() => {
    if (enabled) { loadOpts().then((d) => setList(d[key] || [])); }
  }, [enabled, key]);
  return list;
}

function Editor({ value, kind, options, onSave, onCancel, testid }) {
  const [v, setV] = useState(value || "");
  const [busy, setBusy] = useState(false);
  const save = async () => { setBusy(true); const ok = await onSave(v); setBusy(false); if (ok !== false) onCancel(); };
  const cls = "w-full rounded-md border border-slate-300 bg-white px-2 py-1 text-[13px] text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500/30 focus:border-indigo-500";
  const opts = [...new Set([...(options || []), ...(value ? [value] : [])])];
  return (
    <div className="space-y-1.5" data-testid={`${testid}-editor`}>
      {kind === "select" ? (
        <select className={cls} value={v} onChange={(e) => setV(e.target.value)} autoFocus data-testid={`${testid}-input`}>
          <option value="">— None —</option>
          {opts.map((o) => <option key={o} value={o}>{o}</option>)}
        </select>
      ) : (
        <textarea className={`${cls} min-h-[84px]`} value={v} onChange={(e) => setV(e.target.value)} autoFocus data-testid={`${testid}-input`} />
      )}
      <div className="flex gap-1.5">
        <button type="button" onClick={save} disabled={busy} className="inline-flex items-center gap-1 rounded-md bg-indigo-600 px-2 py-1 text-xs font-medium text-white hover:bg-indigo-700 disabled:opacity-60" data-testid={`${testid}-save`}>
          {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Check className="w-3 h-3" />} Save
        </button>
        <button type="button" onClick={onCancel} disabled={busy} className="inline-flex items-center gap-1 rounded-md border border-slate-200 px-2 py-1 text-xs font-medium text-slate-600 hover:bg-slate-50" data-testid={`${testid}-cancel`}>
          <X className="w-3 h-3" /> Cancel
        </button>
      </div>
    </div>
  );
}

export function InlineEdit({ value, kind = "text", options, canEdit, onSave, testid, children }) {
  const [editing, setEditing] = useState(false);
  if (editing) return <Editor value={value} kind={kind} options={options} onSave={onSave} onCancel={() => setEditing(false)} testid={testid} />;
  return (
    <div className="group flex items-start gap-1.5 min-w-0">
      <div className="min-w-0 flex-1">{children}</div>
      {canEdit && (
        <button type="button" onClick={() => setEditing(true)} aria-label="Edit" className="shrink-0 rounded p-0.5 text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 opacity-60 group-hover:opacity-100 focus:opacity-100 transition-opacity" data-testid={`${testid}-edit-btn`}>
          <Pencil className="w-3.5 h-3.5" />
        </button>
      )}
    </div>
  );
}
